
import { NavLink } from 'react-router-dom';
import { Home, Users, } from 'lucide-react';

const TeleSupportNav = ({ isHovered = true, styles = {}, onToggle }) => {
     const defaultStyles = {
          navItem: {
               display: 'flex',
               alignItems: 'center',
               padding: '8px 12px',
               color: '#111',
               textDecoration: 'none',
               gap: '8px',
               borderRadius: 6,
               marginBottom: '4px',
          },
          navItemActive: {
               backgroundColor: '#e6f0ff',
               color: '#0b63ff',
          },
          container: {
               display: 'flex',
               flexDirection: 'column',
               gap: '6px',
               padding: '8px',
               background: 'transparent',
          },
          submenuItem: {
               padding: '6px 12px',
               display: 'flex',
               alignItems: 'center',
               color: '#333',
               textDecoration: 'none',
               fontSize: '14px',
               border: 'none',
               background: 'none',
               cursor: 'pointer',
               borderRadius: 4,
          },
          submenuItemActive: {
               background: '#e6f7ff',
               color: '#1890ff',
          },
     };

     const s = {
          ...defaultStyles,
          ...styles,
     };


     return (
          <div style={s.container}>
               {/* Dashboard */}
               <NavLink
                    to="/dashboard"
                    style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
               >
                    <Home size={20} />
                    {isHovered && <span style={{ marginLeft: 12 }}>Dashboard</span>}
               </NavLink>

               {/* On-Duty Doctors - Live Support View */}
               <NavLink
                    to="/citywise-on-duty-doctors-new"
                    style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
               >
                    <Users size={20} />
                    {isHovered && <span style={{ marginLeft: 12 }}>Doctors On-Duty </span>}
               </NavLink>


          </div>
     );
};

export const teleSupportNav = (isHovered = true, styles = {}, onToggle) => {
     return <TeleSupportNav isHovered={isHovered} styles={styles} onToggle={onToggle} />;
};

export default TeleSupportNav;
